import React, { useState, ChangeEvent } from 'react';

interface DragAndDropFilesValue {
  files: FileList | null;
  dragging: boolean;
  dragError: boolean;
  changeHandler: (event: ChangeEvent<HTMLInputElement>) => void;
  dragOverHandler: () => void;
  dragLeaveHandler: () => void;
  dropHandler: (event: React.DragEvent<HTMLInputElement>) => void;
}

const useDragAndDropFiles = (
  accept?: string,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void,
): DragAndDropFilesValue => {
  const [files, setFiles] = useState<FileList | null>(null);
  const [dragging, setDragging] = useState(false);
  const [dragError, setDragError] = useState(false);
  const changeHandler = (event: ChangeEvent<HTMLInputElement>): void => {
    if (accept && event.target.files) {
      const acceptedFiles = accept.split(',');

      const allFilesAllowed = Array.from(event.target.files).every((file) =>
        acceptedFiles.some((fileType) => {
          return file.name.indexOf(fileType) > 0 || file.type.includes(fileType.replace(/\*/g, ''));
        }),
      );

      // If files are not accepted, this removes them from the value of the input and creates and error state
      if (!allFilesAllowed) {
        setFiles(null);
        setDragError(true);
        // eslint-disable-next-line no-param-reassign
        event.target.value = '';
        event.preventDefault();
        event.stopPropagation();
        if (onChange) {
          onChange(event);
        }
        return;
      }
    }
    if (event.target.files && event.target.files.length) {
      setFiles(event.target.files);
    } else {
      setFiles(null);
    }
    setDragError(false);
    if (onChange) {
      onChange(event);
    }
  };
  const dragOverHandler = (): void => setDragging(true);
  const dragLeaveHandler = (): void => setDragging(false);
  const dropHandler = (): void => setDragging(false);
  return {
    files,
    dragging,
    dragError,
    changeHandler,
    dragOverHandler,
    dragLeaveHandler,
    dropHandler,
  };
};

export default useDragAndDropFiles;
